import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, Users, CalendarDays, UserCog, Sparkles, Package, LogOut, Menu, X, FileText, Award } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, id: "dashboard" },
  { to: "/clienti", label: "Clienti", icon: Users, id: "clients" },
  { to: "/calendario", label: "Calendario", icon: CalendarDays, id: "calendar" },
  { to: "/operatori", label: "Operatori", icon: UserCog, id: "operators" },
  { to: "/trattamenti", label: "Trattamenti", icon: Sparkles, id: "treatments" },
  { to: "/magazzino", label: "Magazzino", icon: Package, id: "inventory" },
  { to: "/preventivi", label: "Preventivi", icon: FileText, id: "quotes" },
  { to: "/fedelta", label: "Fedeltà", icon: Award, id: "loyalty" },
];

const SideNav = ({ onNav }) => {
  const { logout, user } = useAuth();
  return (
    <div className="flex h-full flex-col">
      <div className="px-6 py-7 border-b border-[#C5A059]/25"><Logo light /></div>
      <nav className="flex-1 px-3 py-6 space-y-1">
        {NAV.map(({ to, label, icon: Icon, id }) => (
          <NavLink key={to} to={to} end={to === "/"} onClick={onNav} data-testid={`nav-${id}`}
            className={({ isActive }) => `group flex items-center gap-3 rounded-xl px-4 py-3 text-sm transition-colors duration-200 ${isActive ? "bg-[#C5A059]/15 text-[#E9CF86] border border-[#C5A059]/40" : "text-[#CFC6B8] border border-transparent hover:bg-white/5 hover:text-white"}`}>
            <Icon className="h-4 w-4" strokeWidth={1.5} />{label}
          </NavLink>
        ))}
      </nav>
      <div className="px-6 py-5 border-t border-[#C5A059]/25">
        <div className="text-xs text-[#9E958A] truncate mb-3" data-testid="current-user-email">{user?.email}</div>
        <button onClick={logout} data-testid="logout-button" className="flex items-center gap-2 text-sm text-[#CFC6B8] hover:text-[#E9CF86] transition-colors">
          <LogOut className="h-4 w-4" strokeWidth={1.5} /> Esci
        </button>
      </div>
    </div>
  );
};

export default function Layout() {
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <aside className="hidden lg:block fixed inset-y-0 left-0 w-64 bg-[#121212]"><SideNav /></aside>
      <header className="lg:hidden sticky top-0 z-30 flex items-center justify-between bg-[#121212] px-4 py-3">
        <Logo light />
        <button onClick={() => setOpen(true)} data-testid="mobile-menu-button" className="text-[#E9CF86]"><Menu /></button>
      </header>
      {open && (
        <div className="lg:hidden fixed inset-0 z-40">
          <div className="absolute inset-0 bg-black/50" onClick={() => setOpen(false)} />
          <aside className="absolute inset-y-0 left-0 w-72 bg-[#121212]">
            <button onClick={() => setOpen(false)} className="absolute right-3 top-3 text-[#E9CF86]" data-testid="mobile-menu-close"><X /></button>
            <SideNav onNav={() => setOpen(false)} />
          </aside>
        </div>
      )}
      <main className="lg:pl-64">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 py-8 lg:py-10"><Outlet /></div>
      </main>
    </div>
  );
}
